// frontend/src/pages/Businesstype/EditBusinessType.jsx
import React, { useEffect, useState } from "react";
import axios from "axios";
import { useNavigate, useParams } from "react-router-dom";
import { toast } from "react-toastify";
import { Briefcase } from "lucide-react";
import "./Businesstype.css";

// ✅ Backend base URL — same pattern as Banktype.jsx
const url = process.env.REACT_APP_BACKEND_URL;

// ✅ Helper: build auth header from localStorage token
const getAuthHeaders = () => {
  const token = localStorage.getItem("token");
  return token ? { Authorization: `Bearer ${token}` } : {};
};

const EditBusinessType = () => {
  const { id } = useParams();
  const navigate = useNavigate();

  const [data, setData] = useState({ name: "" });
  const [businessType, setBusinessType] = useState(null);
  const [submitting, setSubmitting] = useState(false);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchBusinessType = async () => {
      try {
        const res = await axios.get(`${url}/api/businesstype/${id}`, {
          headers: getAuthHeaders(),
        });

        setBusinessType(res.data.data);
        setData({ name: res.data.data.name });
      } catch (err) {
        toast.error(err.response?.data?.message || "Failed to load business type");
        navigate("/ViewBusinesstype");
      } finally {
        setLoading(false);
      }
    };
    fetchBusinessType();
  }, [id, navigate]);

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!data.name.trim()) {
      toast.error("Business type name is required");
      return;
    }

    setSubmitting(true);
    try {
      await axios.put(`${url}/api/businesstype/${id}`, data, {
        headers: getAuthHeaders(),
      });

      toast.success("Business type updated successfully");
      navigate("/ViewBusinesstype");
    } catch (err) {
      toast.error(err.response?.data?.message || "Update failed");
    } finally {
      setSubmitting(false);
    }
  };

  if (loading) {
    return (
      <div className="loading-container">
        <div className="loading">Loading business type details...</div>
      </div>
    );
  }

  return (
    <div className="form-wrapper">
      <div className="businesstype-form-container">
        <h2 className="form-title">
          <Briefcase size={20} /> Edit Business Type
        </h2>

        {/* Business Type Info */}
        {businessType && (
          <div className="entity-info">
            <div className="info-item">
              <span>Created by: {businessType.created_by?.name} on {new Date(businessType.created_at).toLocaleDateString()}</span>
            </div>
            {businessType.updated_by && (
              <div className="info-item">
                <span>Last updated by: {businessType.updated_by?.name} on {new Date(businessType.updated_at).toLocaleDateString()}</span>
              </div>
            )}
          </div>
        )}

        <form className="businesstype-form" onSubmit={handleSubmit}>
          <div className="form-field filled">
            <input
              type="text"
              value={data.name}
              onChange={(e) => setData({ name: e.target.value })}
              placeholder="Enter business type name"
              required
            />
            <label>Business Type Name</label>
          </div>

          <div className="button-group">
            <button
              type="button"
              className="cancel-btn"
              onClick={() => navigate("/ViewBusinesstype")}
            >
              Cancel
            </button>

            <button type="submit" className="submit-btn" disabled={submitting}>
              {submitting ? "Updating..." : "Update Business Type"}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default EditBusinessType;